import styled from 'styled-components';
import { white, grey40, black } from 'Styles/colors';
import { fontBody } from 'Styles/fonts';

import ShopButtonsOriginal from '../../../ShopButtons/ShopButtons';

export const EmptyOrdersCard = styled.div`
  background-color: ${white};
  border: 1px solid ${grey40};
  border-radius: 6px;
  padding: 16px;
  text-align: center;
`;

export const EmptyOrdersTitle = styled.p`
  ${fontBody(16)};
  color: ${black};
  margin: 0;
  padding: 0;
  margin-bottom: 8px;
`;

export const ShopButtons = styled(ShopButtonsOriginal)`
  width: 150px;
`;
